import { render } from "./ResidentControl.vue?vue&type=template&id=cc602c18&scoped=true"
import script from "./ResidentControl.vue?vue&type=script&lang=js"
export * from "./ResidentControl.vue?vue&type=script&lang=js"

import "./ResidentControl.vue?vue&type=style&index=0&id=cc602c18&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc602c18"]])

export default __exports__